import React from "react";
import AprobacionPermisos from "./AprobacionPermisos/AprobacionPermisos";
import HistorialAprobacionesPermisos from "./Historial Aprobacion Permisos/HistorialAprobacionesPermisos";

const DOCTOR_ROUTES: Array<{ path: string, component: any, layout: string }> = [
    
    {
        path: "/AprobacionPermisos",
        component: AprobacionPermisos,
        layout: "/doctor"
    },{
        path: "/historialAprobacionSolicitudes",
        component: HistorialAprobacionesPermisos,
        layout: "/doctor"
    },

];
export default DOCTOR_ROUTES;
